import { DangerAlert } from 'components/common/Alerts';
import Breadcrumb, { BreadcrumbLink } from 'components/common/Breadcrumb';
import Role from 'enums/Role';
import RoleName from 'enums/RoleName';
import User from 'interfaces/User';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import apifetch from 'utils/apifetch';
import extractErrorMessage from 'utils/extractErrorMessage';
import isInRole from 'utils/isInRole';
import { MsalContext } from "../common/msal";


interface Params {
    id: number;
}

interface State {
    isLoading: boolean;
    isSubmitting: boolean;
    hasValidationErrors: boolean;
    errorMessage?: string;
    data: User;
    userName: string;
}

export default class Edit extends React.Component<RouteComponentProps<Params>, State> {
    static contextType = MsalContext;
    context!: React.ContextType<typeof MsalContext>;

    constructor(props: RouteComponentProps<Params>) {
        super(props);

        this.state = {
            isLoading: true,
            isSubmitting: false,
            hasValidationErrors: false,
            data: {} as any,
            userName: ''
        }

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
    }

    public render() {
        return <div className="container">
            <div className="animated fadeIn">
                <Breadcrumb>
                    <BreadcrumbLink to="/">Home</BreadcrumbLink>
                    <BreadcrumbLink to="/users">Users</BreadcrumbLink>
                    <BreadcrumbLink isActive={true}>Edit User</BreadcrumbLink>
                </Breadcrumb>
                <div className="card card--form">
                    <div className="card-block">
                        <form className="form" onSubmit={this.handleFormSubmit}>
                            <h3 className="block-title">Edit User</h3>
                            <div className="form-wrapper">
                                {this.state.hasValidationErrors && <DangerAlert name="dangerAlert">{this.state.errorMessage || "An error occured."}</DangerAlert>}
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Username</span>
                                        <input type="text" name="username" className="form-control" onChange={this.handleInputChanged} required maxLength={50} value={this.state.data.username} readOnly />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">First Name</span>
                                        <input type="text" name="firstName" className="form-control" onChange={this.handleInputChanged} maxLength={50} value={this.state.data.firstName} readOnly />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Last Name</span>
                                        <input type="text" name="lastName" className="form-control" onChange={this.handleInputChanged} maxLength={50} value={this.state.data.lastName} readOnly />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Initials</span>
                                        <input type="text" name="initials" className="form-control" onChange={this.handleInputChanged} maxLength={2} value={this.state.data.initials} readOnly />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Email</span>
                                        <input type="text" name="email" className="form-control" onChange={this.handleInputChanged} maxLength={100} value={this.state.data.email} readOnly />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Role</span>
                                        <select name="roleId" className="form-control select2-single" onChange={this.handleInputChanged} value={this.state.data.roleId}
                                            disabled={this.state.data.username === this.state.userName}>
                                            <option value={Role.Admin}>Admin</option>
                                            <option value={Role.Support}>Support</option>
                                            <option value={Role.Sales}>Sales</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="form-actions">
                                <div className="text-center">
                                    {this.state.isSubmitting
                                        ? <button type="submit" className="btn btn-primary" disabled><i className="icon-spinner icon-pulse"></i> Saving</button>
                                        : <button type="submit" className="btn btn-primary">Save</button>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>;
    }

    public componentWillMount() {
        if (isInRole(RoleName.Admin)) {
            return true;
        }

        this.props.history.push("/users");
        return false;
    }

    public async componentDidMount() {
        let response = await apifetch(`users/${this.props.match.params.id}`, undefined, true);
        if (response.ok) {
            let data = await response.json() as User;
            let accUserName = '';
            const accounts = this.context.accounts;
            if (accounts.length > 0) {
                const account = this.context.accounts[0];
                if (account) {
                    accUserName = account.username;
                }
            }
            this.setState({
                isLoading: false,
                data: data,
                userName: accUserName
            });

            document.title = "Edit User - " + SITE_NAME;
        } else {
            this.props.history.push("/users");
        }
    }

    private async handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        this.setState({
            isSubmitting: true,
        });

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
                errorMessage: undefined,
            });
        }

        let response = await apifetch(`users/${this.props.match.params.id}`, {
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json",
            }),
            method: "PUT",
            body: JSON.stringify(this.state.data),
        }, true);
        if (response.ok) {
            this.props.history.push("/users");
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({
                isSubmitting: false,
                hasValidationErrors: true,
                errorMessage: errorText,
            });
        }
    }

    private handleInputChanged(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        let currentTarget = event.currentTarget;

        this.setState(prevState => ({
            data: {
                ...prevState.data,
                [currentTarget.name]: currentTarget.value,
            }
        }));
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/users/Edit.tsx